import type { DictionaryProviderValue } from '@lib/providers/dictionary-provider'

export interface IconButtonAriaLabelEntry {
    key: string
    fallback: string
}

export const ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS: Record<string, IconButtonAriaLabelEntry> = {
    CLOSE: { key: 'STO.COMMON.CLOSE', fallback: 'Close modal' },
    CLOSE_TOAST: { key: 'STO.COMMON.TOAST.CLOSE', fallback: 'Close notification' },
    DECREMENT_VALUE: { key: 'STO.COMPONENTS.ARIA.DECREMENT_VALUE', fallback: 'Decrease value' },
    INCREMENT_VALUE: { key: 'STO.COMPONENTS.ARIA.INCREMENT_VALUE', fallback: 'Increase value' },
    OPEN_CONTEXT_MENU: { key: 'STO.COMPONENTS.ARIA.OPEN_CONTEXT_MENU', fallback: 'Open menu' },
    CLEAR_SEARCH: { key: 'STO.COMPONENTS.ARIA.CLEAR_SEARCH', fallback: 'Clear search' },
    SUBMIT_SEARCH: { key: 'STO.COMPONENTS.ARIA.SUBMIT_SEARCH', fallback: 'Search' },
    TABLE_ROW_EXPAND: { key: 'STO.COMPONENTS.ARIA.TABLE_ROW_EXPAND', fallback: 'Expand row' },
    TABLE_ROW_COLLAPSE: { key: 'STO.COMPONENTS.ARIA.TABLE_ROW_COLLAPSE', fallback: 'Collapse row' },
    TABLE_ROW_DETAILS_EXPANDED: {
        key: 'STO.COMPONENTS.ARIA.TABLE_ROW_DETAILS_EXPANDED',
        fallback: 'Row details expanded',
    },
    TABLE_ROW_DETAILS: {
        key: 'STO.COMPONENTS.ARIA.TABLE_ROW_DETAILS',
        fallback: 'Row details',
    },
    PAGINATION_PREVIOUS: { key: 'STO.COMPONENTS.ARIA.PAGINATION_PREVIOUS', fallback: 'Previous page' },
    PAGINATION_NEXT: { key: 'STO.COMPONENTS.ARIA.PAGINATION_NEXT', fallback: 'Next page' },
    NAVIGATE_BACK: { key: 'STO.COMPONENTS.ARIA.NAVIGATE_BACK', fallback: 'Go back' },
    DOWNLOAD_FILE: { key: 'STO.COMPONENTS.ARIA.DOWNLOAD_FILE', fallback: 'Download file' },
    EDIT_FILE_SELECTION: { key: 'STO.COMPONENTS.ARIA.EDIT_FILE_SELECTION', fallback: 'Change file' },
    REMOVE_FILE_SELECTION: { key: 'STO.COMPONENTS.ARIA.REMOVE_FILE_SELECTION', fallback: 'Remove file' },
    SELECT_CLEAR: { key: 'STO.COMPONENTS.ARIA.SELECT_CLEAR', fallback: 'Clear selection' },
}

export type IconButtonAriaLabelId = keyof typeof ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS

export const resolveIconButtonAriaLabel = (
    dictionary: Pick<DictionaryProviderValue, 'getText'> | undefined,
    entry: IconButtonAriaLabelEntry,
): string => dictionary?.getText(entry.key, undefined, entry.fallback) ?? entry.fallback
